// Pure helpers for the file-tree context menu.

const MARGIN = 8;

export function clampMenuPosition({
  x, y, menuWidth, menuHeight, viewportWidth, viewportHeight,
}) {
  const maxX = viewportWidth - menuWidth - MARGIN;
  const maxY = viewportHeight - menuHeight - MARGIN;
  return {
    x: Math.max(MARGIN, Math.min(x, maxX)),
    y: Math.max(MARGIN, Math.min(y, maxY)),
  };
}

export function wikilinkFor(path) {
  const stripped = path.toLowerCase().endsWith('.md')
    ? path.slice(0, -3)
    : path;
  return `[[${stripped}]]`;
}

// Builds the ordered item array for a tree context-menu variant. Pure so it
// can be unit-tested without mounting the (TDZ-fragile) Workspace component.
// Item shape: { label, action, shortcut?, danger?, separator?, section? }.
// Glyphs and order are the contract from the editability mockup
// (docs/mockups/2026-05-22-editability/script.js MENU_FILE/MENU_FOLDER/MENU_EMPTY).
export function buildContextMenuItems({ kind, isMulti, selectedCount }) {
  if (isMulti) {
    return [
      { label: `Delete ${selectedCount} files…`, action: 'delete-all', danger: true },
      { label: 'Move to…', action: 'move-to' },
      { label: 'Copy paths', action: 'copy-paths' },
    ];
  }
  if (kind === 'file') {
    return [
      { label: 'Open',            shortcut: '↵',  action: 'open' },
      { label: 'Open in new tab', shortcut: '⌘↵', action: 'open-new-tab' },
      { separator: true },
      { label: 'Rename',          shortcut: 'F2', action: 'rename' },
      { label: 'Duplicate',       shortcut: '⌘D', action: 'duplicate' },
      { label: 'Copy path',       shortcut: '⌘C', action: 'copy-path' },
      { label: 'Copy as wikilink',                action: 'copy-wikilink' },
      { separator: true },
      { label: 'History…',        shortcut: '⌘Y', action: 'history' },
      { separator: true },
      { label: 'Delete…',         shortcut: 'Del', action: 'delete', danger: true },
    ];
  }
  if (kind === 'folder') {
    return [
      { section: 'inside this folder' },
      { label: 'New file…',     shortcut: '⌘N',  action: 'new-file' },
      { label: 'New folder…',   shortcut: '⌘⇧N', action: 'new-folder' },
      { separator: true },
      { label: 'Rename',        shortcut: 'F2',  action: 'rename' },
      { label: 'Copy path',     shortcut: '⌘C',  action: 'copy-path' },
      { separator: true },
      { label: 'Delete folder…',                 action: 'delete', danger: true },
    ];
  }
  // background / empty
  return [
    { label: 'New file…',   shortcut: '⌘N',  action: 'new-file' },
    { label: 'New folder…', shortcut: '⌘⇧N', action: 'new-folder' },
    { separator: true },
    { label: 'Expand all',                   action: 'expand-all' },
    { label: 'Collapse all',                 action: 'collapse-all' },
  ];
}
